import React, { useEffect, useState } from 'react';
import { Table, Row, Col, Divider, Descriptions, Card, Typography } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { debitNoteService } from '../../../../../services';

const { Title } = Typography;

const DebitPDF = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState([]);
    const [data, setData] = useState([])

    const columns = [
        {
            title: 'S.No',
            dataIndex: 'sno',
            key: 'sno',
        },
        {
            title: 'Debit Against',
            dataIndex: 'debitAgainst',
            key: 'debitAgainst',
            render: (text) => text === 0 ? `Expense` : `Invoice# ${text}`
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Amount (USD)',
            dataIndex: 'amount',
            key: 'amount',
            width: 250,
        },
    ];

    // const handlePrint = () => {
    //     const printContents = document.getElementById('printableArea').innerHTML;
    //     const originalContents = document.body.innerHTML;
    //     document.body.innerHTML = printContents;
    //     window.print();
    //     document.body.innerHTML = originalContents;
    //     window.location.reload();
    //     navigate('/accounts/debit-notes');
    // };

    const handlePrint = () => {
        window.print();
    }

    const initialize = async () => {
        setLoading(true)
        const { success, data } = await debitNoteService.viewPDF(id);
        setLoading(false)
        if (success) {
            const tableData = [
                {
                    key: '1',
                    sno: '1',
                    debitAgainst: data.debit.invoice_id,
                    description: data.debit.description,
                    amount: data.debit.amount,
                },
            ]
            setFormData(data);
            setData(tableData)
        }
    }


    useEffect(() => {
        initialize()
        const beforePrint = () => {
            console.log('Printing...');
        };

        const afterPrint = () => {
            navigate('/accounts/debit-notes');
        };

        window.addEventListener('beforeprint', beforePrint);
        window.addEventListener('afterprint', afterPrint);

        if (!loading) { handlePrint() };

        return () => {
            window.removeEventListener('beforeprint', beforePrint);
            window.removeEventListener('afterprint', afterPrint);
        };
    }, [loading]);

    return (
        <div style={{ display: 'flex', flexDirection: "column", justifyContent: 'center', alignItems: 'center', height: 'auto', width: "auto", backgroundColor: 'transparent', fontSize: '18px' }}>
            <Card id="printableArea" style={{ width: '100%', padding: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <img src="/images/ctrade-logo.png" alt="Ctrade Logo" style={{ width: 100, marginBottom: 20 }} />
                        <Title level={1} style={{ fontSize: '32px' }}>Debit Note</Title>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                        <p>3902 SWINGLE RD</p>
                        <p>HOUSTON, TX 77047</p>
                        <p>UNITED STATES</p>
                        <p>Mobile: +1 832-819-2622</p>
                        <p>Email: trade@ctrade.us</p>
                    </div>
                </div>
                <Row>
                    <Col span={24} style={{ textAlign: "right", fontSize: 20 }}>
                        <div>
                            <Title level={2}>Debit Number #: {formData?.debit?.id}</Title>
                        </div>
                    </Col>
                </Row>
                <Divider style={{ borderTop: '2px solid #B83D3D' }} />
                <Row gutter={20}>
                    <Col span={24}>
                        <Descriptions bordered column={2}>
                            <Descriptions.Item label={<strong style={{ fontSize: 15 }}>Debit Note Issued To</strong>}>
                                <span style={{ fontSize: 15 }}>{formData?.customer?.name}</span>
                            </Descriptions.Item>
                            <Descriptions.Item label={<strong style={{ fontSize: 15 }}>Customer Address</strong>}>
                                <span style={{ fontSize: 15 }}>{formData?.customer?.address}</span>
                            </Descriptions.Item>
                            <Descriptions.Item label={<strong style={{ fontSize: 15 }}>Date</strong>}>
                                <span style={{ fontSize: 15 }}>{formData?.debit?.issue_date}</span>
                            </Descriptions.Item>
                            <Descriptions.Item label={<strong style={{ fontSize: 15 }}>Debit Note #</strong>}>
                                <span style={{ fontSize: 15 }}>{id}</span>
                            </Descriptions.Item>
                        </Descriptions>
                    </Col>
                </Row>
                <Divider style={{ borderTop: '2px solid #B83D3D' }} />
                <Row style={{ marginTop: 30 }}>
                    <Col span={24}>
                        <Table
                            className="custom-table"
                            columns={columns}
                            dataSource={data}
                            pagination={false}
                            bordered
                            summary={() => (
                                <Table.Summary.Row style={{ fontSize: "18px" }}>
                                    <Table.Summary.Cell colSpan={3}></Table.Summary.Cell>
                                    <Table.Summary.Cell colSpan={1}><strong>Amount Debit: ${formData?.debit?.amount}</strong></Table.Summary.Cell>
                                </Table.Summary.Row>
                            )}
                        />
                    </Col>
                </Row>
                <Divider style={{ borderTop: '2px solid #B83D3D' }} />
                <Row>
                    <Col span={24} style={{ textAlign: "center", color: '#E0D7D4' }}>
                        <p>THANK YOU FOR DOING BUSINESS WIITH C TRADE USA INC.</p>
                    </Col>
                </Row>
            </Card>
        </div>
    );
};

export default DebitPDF;
